import { useNavigate } from "react-router-dom";
import { ICandidates } from "../types/types";
import { CandidateMiniCard } from "@src/shared/components/CandidateMiniCard/CandidateMiniCard";
import { monthsToYearsString } from "@src/shared/utils/monthToYears";
import { ERECUEST_STATUS } from "@src/shared/types/enums";
import { Button } from "@src/shared/components/Button/Button";

import styles from "./styles.module.scss";

interface ISearchMiniReasult {
  request_uuid: string;
  candidates: ICandidates[];
  status: string;
  handleOpenList: () => void;
  isShowAll: boolean;
  allCandidates?: number;
}

export const SearchMiniReasult = ({
  request_uuid,
  candidates,
  allCandidates,
  handleOpenList,
  isShowAll,
  status,
}: ISearchMiniReasult) => {
  const navigate = useNavigate();
  const visibleCandidates = isShowAll ? candidates : candidates.slice(0, 4);

  const isPending = status === ERECUEST_STATUS.PANDING;

  const isNoCandidates =
    status === ERECUEST_STATUS.NO_CANDIDATES ||
    (status === ERECUEST_STATUS.DONE && candidates.length === 0);
  const isHHTokensExhausted = status === ERECUEST_STATUS.HH_TOKENS_EXHAUSTED;
  const hasCandidates = candidates.length > 0;

  const onCandidate = (candidate_id: string) => {
    navigate(
      `/candidate?request_uuid=${request_uuid}&candidate_id=${candidate_id}`,
    );
  };

  return (
    <>
      {isPending && (
        <div className={styles.emptySearchResult}>
          <div className={styles.searchResultCountingTitle}>
            Подбираем кандидатов ...
          </div>
        </div>
      )}

      {isHHTokensExhausted && (
        <div className={styles.emptySearchResult}>
          <div className={styles.searchResultCountingTitle}>
            Системная ошибка, обратитесь в службу технической поддержки{" "}
          </div>
        </div>
      )}

      {isNoCandidates && (
        <div className={styles.emptySearchResult}>
          <div className={styles.searchResultCountingTitle}>
            Кандидаты не найдены
          </div>
        </div>
      )}

      {hasCandidates && (
        <>
          <div className={styles.searchResultCounting}>
            <div className={styles.searchResultCountingTitle}>
              Результаты запросов ({visibleCandidates.length} из {allCandidates}
              )
            </div>
          </div>

          <div className={styles.searchMiniResultWrap}>
            {visibleCandidates.map((curCandidate) => {
              const relevantExperience = monthsToYearsString(
                curCandidate?.relevant_experience_years,
              );

              const isShowNeedAtentionInfo = !!curCandidate?.warnings.length;

              return (
                <div
                  key={curCandidate.id}
                  className={styles.searchMiniresult}
                  onClick={() => onCandidate(curCandidate.id)}
                >
                  <CandidateMiniCard
                    age={curCandidate.age}
                    candidate_id={curCandidate.id}
                    request_uuid={request_uuid || ""}
                    desired_position={curCandidate.desired_position}
                    city={curCandidate.city}
                    relevant_experience_years={relevantExperience}
                    salary={curCandidate.salary}
                    scores={curCandidate.scores}
                    gender={curCandidate.gender}
                    isShowNeedAtentionInfo={isShowNeedAtentionInfo}
                    isViewed={curCandidate.viewed}
                  />
                </div>
              );
            })}
          </div>
          {(allCandidates || candidates.length) > 4 && (
            <div className={styles.footer}>
              <Button
                onClick={handleOpenList}
                btnText={isShowAll ? "Свернуть" : "Показать всех кандидатов"}
              />
              <div className={styles.emptyBlock} />
            </div>
          )}
        </>
      )}
    </>
  );
};
